import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { MediaPickerMode } from '~admin/view/components/ui/form/fields/media/media-overlay/media-picker-mode-inner.component';
import { OptionsSwitch, Side } from '~web/view/components/ui/options-switch.component';

interface Props {
  enabled: boolean;
  mode: MediaPickerMode;
  onModeSet?: (value: MediaPickerMode) => void;
}

export const MediaPickerModeSwitch: React.FunctionComponent<Props> = ({
  enabled,
  mode,
  onModeSet,
}) => {
  const { t } = useTranslation();

  if (!enabled) {
    return null;
  }

  return (
    <StyledOptionsSwitch
      optionLeft={t('createEvent.eventDetails.media.overlay.search.button')}
      optionRight={t('createEvent.eventDetails.media.overlay.upload.button')}
      initialOption={mode === MediaPickerMode.SEARCH ? Side.Left : Side.Right}
      onChange={(option: Side): void => {
        option === Side.Left
          ? onModeSet?.(MediaPickerMode.SEARCH)
          : onModeSet?.(MediaPickerMode.UPLOAD);
      }}
    />
  );
};

const StyledOptionsSwitch = styled(OptionsSwitch)`
  // TODO(Dmitry): Figure out why animations glitches
  > .options-switch-toggle {
    transition: none;
  }

  .options-switch-label {
    transition: none;
  }
`;



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/media/media-overlay/media-picker-mode-switch.component.tsx